import React, { useState, useContext, useEffect } from "react";
import { Button, InputGroup, Tooltip, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ManagePlanLayout,
  CsplTable as Table,
  AddPlans,
  LoaderWrapper,
  SliderPanel,
  FormControlSearch,
  GetInitials,
  AddToolTip,
} from "../../../components";
import { isEmpty, get } from "lodash";
import {
  getPathWithParam,
  getAdvancedPathWithParam,
  MANAGE_PLAN_ROUTES,
  FLOW_TYPES,
  MANAGE_MASTERS_ROUTES,
} from "../../../utils";
import { createPlanStore } from "../../../contexts";
import { useRequest, useDeepEffect } from "../../../abstracts";
import {
  GetTradingPartnerList,
  GetTradingPartner,
  UpsertPlanWithClearingPartner,
  GetPlanTradingPartnerList,
} from "../../../services";
import ClearingPartnerCard from "./ClearingPartnerCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faBadgeCheck } from "@fortawesome/pro-solid-svg-icons";
import { faCircle } from "@fortawesome/pro-light-svg-icons";
const recordsToDisplay = [
  {
    id: 1,
    clearingPartnerName: "Arise States",
    assosiatedPlans: 20,
  },
  {
    id: 2,
    clearingPartnerName: "BN States",
    assosiatedPlans: 25,
  },
  {
    id: 3,
    clearingPartnerName: "AK Computers",
    assosiatedPlans: 15,
  },
  {
    id: 4,
    clearingPartnerName: "UMA engitech",
    assosiatedPlans: 30,
  },
  {
    id: 5,
    clearingPartnerName: "VAR",
    assosiatedPlans: 10,
  },
  {
    id: 6,
    clearingPartnerName: "JS Morgan Chase",
    assosiatedPlans: 12,
  },
  {
    id: 7,
    clearingPartnerName: "Paribas",
    assosiatedPlans: 10,
  },
];
const columns = [
  {
    id: "clearingPartnerId",
    label: "Clearing Partner ID",
    style: { paddingLeft: "20px", fontSize: "14px", width: "60%" },
    className: "grey-text font-weight-700",
    styleName: "trade-flex-column w-60",
  },
  {
    id: "bankDetails",
    label: "BankDetails",
    style: { fontSize: "14px", width: "40%", paddingLeft: "10px" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-40",
  },
];
const clearingPartnerRecords = [
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
  {
    clearingPartnerId: "CP-001",
    clearingPartnerName: "Arise States",
    accountNumber: "XXXXX789",
    bankDetails: "Bank of America",
  },
];
const ClearingPartnerContainer = (props) => {
  const { state, dispatch } = useContext(createPlanStore);
  const [clearingPartnerId, setClearingPartnerId] = useState(0);
  const [clearingPartnerDetails, setClearingPartners] = useState([]);

  const [clearingPartnerAccounts, setClearingPartnerAccounts] = useState([]);
  const [clearingPartnerIds, setClearingPartnerIds] = useState([]);
  const [planClearingPartnerDetails, setPlanClearingPartnerDetails] = useState(
    []
  );
  const [open, setOpen] = useState(false);
  const [defaultClearingPartner, setDefaultClearingPartner] = useState(0);
  const [editDefaultSlider, setEditDefaultSlider] = useState(false);
  console.log(
    "clearingPartnerDetails",
    clearingPartnerIds,
    defaultClearingPartner,
    planClearingPartnerDetails?.find((e) => e.isDefault)?.id
  );

  useDeepEffect(() => {
    if (get(state, "planId")) {
      GetPlanTradingPartnerList(get(state, "planId")).then((res) => {
        if (res) {
          setPlanClearingPartnerDetails(
            get(res, "planAssociatedClearingPartnerAccounts", [])
          );
          setClearingPartnerIds(
            get(res, "planAssociatedClearingPartnerAccounts", [])?.map(
              (e) => e.id
            )
          );
          // console.log("hit")
          // setDefaultClearingPartner((planClearingPartnerDetails.find(e => e.isDefault))?.id);
        }
      });
    }
  }, [state, open, editDefaultSlider]);
  useDeepEffect(() => {
    if (!isEmpty(planClearingPartnerDetails)) {
      setDefaultClearingPartner(
        planClearingPartnerDetails.find((e) => e.isDefault)?.id
      );
    }
  }, [planClearingPartnerDetails]);
  useDeepEffect(() => {
    GetTradingPartnerList().then((res) => {
      if (res) {
        setClearingPartners(res);
      }
    });
  }, [open]);
  useDeepEffect(() => {
    if (clearingPartnerDetails)
      setClearingPartnerId(clearingPartnerDetails[0]?.id ?? 0);
  }, [clearingPartnerDetails]);
  useEffect(() => {
    if (clearingPartnerId) {
      GetTradingPartner(clearingPartnerId)
        .then((res) => {
          setClearingPartnerAccounts(
            get(res, "clearingPartnerListResponses", [])
          );
        })
        .catch((err) => {});
    }
  }, [clearingPartnerId]);

  const onClearingPartnerClick = (id) => {
    setClearingPartnerId(id);
  };

  const onAddClick = () => {
    setOpen(!open);
  };
  const searchTextBox = (e) => {
    if (e.key === "Enter") {
    }
  };
  const buttons = [
    {
      label: "Add",
      variant: "primary",
      type: "button",
      onClick: onAddClick,
    },
  ];
  const onCancelClick = () => {
    setOpen(!open);
  };
  const onAddPlanClick = () => {
    const payload = {
      planId: parseInt(get(state, "planId", 0)),
      clearingPartnerAccountIds: clearingPartnerIds,
      defaultClearingPartnerAccountId: defaultClearingPartner
        ? defaultClearingPartner
        : clearingPartnerIds[0],
    };
    UpsertPlanWithClearingPartner(payload)
      .then((res) => {
        setOpen(false);
        setEditDefaultSlider(false);
      })
      .catch((err) => {});
  };
  const editDefault = () => {
    setEditDefaultSlider(!editDefaultSlider);
  };
  const rightClearingPartnerCard = (details) => {
    const {
      clearingPartnerLogo,
      clearingPartnerName,
      assosiatedPlans,
    } = details;

    return (
      <>
        <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
          {!isEmpty(clearingPartnerLogo) ? (
            <img
              alt=""
              src={clearingPartnerLogo}
              style={{ width: "90px", height: "74px" }}
              className="img-fluid"
            />
          ) : (
            <GetInitials name={clearingPartnerName} />
          )}
        </div>

        <div className="clearing-partner-description-box">
          <AddToolTip
            name={clearingPartnerName}
            className="ft-14 font-weight-500 pb-3 clearing-partner-name"
          />
          <div className="clearing-partner-associated-plans">
            {assosiatedPlans} Associated Plans
          </div>
        </div>
      </>
    );
  };

  const TableContent = {
    clearingPartnerId: (a) => {
      // console.log(a, "a");
      const addClearingPartners = (id) => {
        setClearingPartnerIds([...clearingPartnerIds, id]);
      };
      const removeClearingPartners = (id) => {
        const filtered = clearingPartnerIds.filter((item) => item !== id);
        setClearingPartnerIds(filtered);
        console.log(defaultClearingPartner === id, "removed");
        defaultClearingPartner === id && setDefaultClearingPartner(0);
      };
      return (
        <div className={a.styleName}>
          {clearingPartnerIds?.includes(a.id) ? (
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="mr-2 primary-small"
              style={{ cursor: "pointer" }}
              onClick={() => removeClearingPartners(a.id)}
            />
          ) : (
            <FontAwesomeIcon
              icon={faCircle}
              className="mr-2"
              color="#7C7C80"
              onClick={() => addClearingPartners(a.id)}
              style={{ cursor: "pointer" }}
            />
          )}

          <div className="clearing-partner-id-text">
            <div className="transaction-card-top-row">
              {a.clearingPartnerId}
            </div>
            <AddToolTip name={a.description}>
              <div className="transaction-card-bottom-row">
                {a.description?.slice(0, 30)}...
              </div>
            </AddToolTip>
          </div>
        </div>
      );
    },
    bankDetails: (a) => {
      return (
        <div className={a.styleName}>
          <div className="transaction-card-top-row">{a.bankName}</div>
          <div className="transaction-card-bottom-row">{a.accountNumber}</div>
        </div>
      );
    },
    default: (a) => null,
  };
  const isLoading = !isEmpty(clearingPartnerAccounts);
  console.log(planClearingPartnerDetails, "clearingPartnerAccounts");
  return (
    <LoaderWrapper isLoading={false}>
      <ManagePlanLayout buttons={buttons}>
        {isEmpty(planClearingPartnerDetails) ? (
          <AddPlans
            menu="plan"
            subMenu="clearingPartner"
            content={
              <>
                No Clearing Partners have been
                <br />
                added for this plan.
              </>
            }
            buttonLabel="Add Clearing Partner"
            onPrimaryClick={onAddClick}
          />
        ) : (
          <div className="w-100">
            <div className="d-flex w-100 align-items-center justify-content-between mb-4">
              <div className="m-0 plan-heading">
                Clearing Partner Information
              </div>
              <div
                className="edit-button-clearing-Partner"
                onClick={editDefault}
              >
                Edit Default Account
              </div>
            </div>
            {planClearingPartnerDetails?.map((e, i) => {
              return (
                <div className="clearing-partner-added-cards">
                  <div className="left-component-clearing-partner">
                    <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
                      {!isEmpty(e.logo) ? (
                        <img
                          alt=""
                          src={e.logo}
                          style={{ width: "90px", height: "74px" }}
                          className="img-fluid"
                        />
                      ) : (
                        <GetInitials name={e.name} />
                      )}
                    </div>

                    <div className="clearing-partner-description-box">
                      <AddToolTip
                        name={e.name}
                        className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                      />
                      <div className="clearing-partner-associated-plans">
                        {e.totalPlans ?? 0} Associated Plans
                      </div>
                      {e.isDefault && (
                        <div className="clearing-partner-associated-plans">
                          <FontAwesomeIcon icon={faBadgeCheck} /> Default
                          Account
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="right-component-clearing-partner">
                    <div className="ft-14 font-weight-500 pb-3 clearing-partner-name">
                      Clearing Partner Account Details
                    </div>
                    <AddToolTip
                      name={e.clearingPartnerId}
                      className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                    />
                    <div className="clearing-partner-associated-plans">
                      {e.description}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <SliderPanel
          isOpen={editDefaultSlider}
          size="50"
          onClose={editDefault}
          showCancel={false}
        >
          <div className="clearing-partner-inside-content">
            <div className="d-flex justify-content-between align-baseline">
              <div>
                <p className="investment-heading">Edit Default Account</p>
              </div>
              <div>
                <Button variant="secondary" onClick={editDefault}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={onAddPlanClick}
                  className="ml-4"
                >
                  Set As Default Account
                </Button>
              </div>
            </div>
            {!isEmpty(planClearingPartnerDetails) &&
              planClearingPartnerDetails.map((e, i) => {
                return (
                  <div className="clearing-partner-added-cards">
                    <div className="left-component-clearing-partner">
                      <Form.Check // prettier-ignore
                        type={"radio"}
                        name="group1"
                        value={e.id}
                        id={`default-radio-${i}`}
                        onChange={(e) =>
                          setDefaultClearingPartner(parseInt(e.target.value))
                        }
                      />

                      <div className="clearing-partner-icon-wrapper d-flex justify-content-center">
                        {!isEmpty(e.logo) ? (
                          <img
                            alt=""
                            src={e.logo}
                            style={{ width: "90px", height: "74px" }}
                            className="img-fluid"
                          />
                        ) : (
                          <GetInitials name={e.name} />
                        )}
                      </div>

                      <div className="clearing-partner-description-box">
                        <AddToolTip
                          name={e.name}
                          className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                        />
                        <div className="clearing-partner-associated-plans">
                          {e.totalPlans} Associated Plans
                        </div>
                      </div>
                    </div>
                    <div className="right-component-investment-clearing-partner">
                      <div className="inner-bank-details">
                        <div className="ft-14 font-weight-500 pb-3 clearing-partner-name">
                          Clearing Partner Account Details
                        </div>
                        <AddToolTip
                          name={e.clearingPartnerId}
                          className="ft-14 font-weight-500 pb-3 clearing-partner-name"
                        />
                        <div className="clearing-partner-associated-plans">
                          {e.description}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </SliderPanel>
        <SliderPanel
          isOpen={open}
          size="50"
          onClose={() => onCancelClick()}
          showCancel={false}
        >
          <div className="clearing-partner-inside-content">
            <div className="d-flex justify-content-between align-baseline">
              <div>
                <p className="investment-heading">Add Clearing Partner</p>
              </div>
              <div>
                <Button variant="secondary" onClick={onCancelClick}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={onAddPlanClick}
                  className="ml-4"
                >
                  Add To Plan
                </Button>
              </div>
            </div>
            <div className="clearing-partners-list-container">
              <div className="clearing-partners-list">
                {clearingPartnerDetails?.map((item, index) => {
                  return (
                    <ClearingPartnerCard
                      {...item}
                      onSelect={onClearingPartnerClick}
                    />
                  );
                })}
              </div>
              <div className="clearing-partners-list-item">
                <p className="investment-heading">Clearing Partner ID</p>
                <div className="search-bar-clearing-partner">
                  <InputGroup>
                    <InputGroup.Prepend>
                      <div className="search-icon-postion">
                        <i className="fas fa-search" aria-hidden="true"></i>
                      </div>
                    </InputGroup.Prepend>
                    <FormControlSearch
                      size="xs"
                      type="search"
                      className="plan-search-box pad-left-search"
                      placeholder="Search"
                      onKeyPress={(e) => {
                        searchTextBox(e);
                      }}
                    />
                  </InputGroup>
                </div>
                <div className="clearing-partner-added-container">
                  <div className="clearing-partner-subjects">
                    <div className="clearing-partner-recently-added">
                      Recently Added/Modified
                    </div>
                    <div className="clearing-partner-records">
                      {clearingPartnerAccounts.length ?? 0} Records found
                    </div>
                  </div>
                  <Link
                    className="create-partner-id"
                    to={`${MANAGE_MASTERS_ROUTES.CLEARING_PARTNER_DETAILS}/${clearingPartnerId}`}
                  >
                    + Create Partner ID
                  </Link>
                </div>
                <div className="clearing-partner-card-list">
                  <div className="column-filters-clearing-partner">
                    {columns.map((_) => (
                      <div className={_.className} style={{ ..._.style }}>
                        {" "}
                        {_.label}
                      </div>
                    ))}
                  </div>
                  {/* <LoaderWrapper isLoading={isLoading}> */}
                  {!isEmpty(clearingPartnerAccounts) &&
                    clearingPartnerAccounts?.map((e, i) => {
                      return (
                        <div className="clearing-partner-list-table-component trade-transaction-card">
                          {columns.map((a, b) => {
                            // console.log(a, "regs");
                            // const args = {...a,...e}
                            return TableContent[a.id]({ ...a, ...e });
                          })}
                        </div>
                      );
                    })}
                  {/* </LoaderWrapper> */}
                </div>
              </div>
            </div>
          </div>
        </SliderPanel>
      </ManagePlanLayout>
    </LoaderWrapper>
  );
};

export default ClearingPartnerContainer;
